export const DEFAULT_CONFIG = {
    value: 51,
    range: [51, 1000]
};
